"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import rightChevron from "@svb/svbbranding/dist/assets/icons/chevron_right.svg";
/**
 * SVBBreadCrumbs
 * All these properties are properties  of props
 * @param breadCrumbs: list of breadcrumbs to be displayed,
 * @param href: image src for the card,
 * @returns HTML tag with content
 */
const SVBBreadCrumb = props => {
  const extraClasses = props.extraClasses;
  const breadCrumbsList = props.breadCrumbs || [{}];
  return /*#__PURE__*/_react.default.createElement("ul", {
    key: "breadCrumbUl",
    className: extraClasses ? "d-flex list breadcrumbs--workspace d--flex align--center pl--24 pr--24" : "list breadcrumbs--workspace d--flex align--center pl--24 pr--24"
  }, breadCrumbsList.map((val, index) => {
    const dataTestid = val === null || val === void 0 ? void 0 : val.dataTestId;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: 'bcLi' + index,
      "data-testid": dataTestid ? dataTestid : null,
      className: extraClasses ? "d-flex" : ""
    }, /*#__PURE__*/_react.default.createElement("a", {
      key: 'bcA' + index,
      href: val === null || val === void 0 ? void 0 : val.link,
      className: index == breadCrumbsList.length - 1 ? 'last-child' : ''
    }, val.breadCrumb), /*#__PURE__*/_react.default.createElement("div", null, index !== breadCrumbsList.length - 1 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "faq-text02"
    }, "/") : ""));
  }));
};
var _default = SVBBreadCrumb;
exports.default = _default;